import { combineReducers } from 'redux';
import { createReducer } from 'typesafe-actions';

import { fetchProviderDetailsAsync } from 'store/providerDetails/actions';

import type { ProviderDetails, ProviderDetailsErrors } from 'ProviderDetails-Types';

export const isFetching = createReducer(false as boolean)
  .handleAction([fetchProviderDetailsAsync.request], () => true)
  .handleAction(
    [fetchProviderDetailsAsync.success, fetchProviderDetailsAsync.failure],
    () => false,
  );

export const providerDetails = createReducer({} as ProviderDetails)
  .handleAction(fetchProviderDetailsAsync.success, (_state, action) => action.payload)
  .handleAction(fetchProviderDetailsAsync.failure, () => ({} as ProviderDetails));

export const errors = createReducer([] as ProviderDetailsErrors[]).handleAction(
  fetchProviderDetailsAsync.failure,
  (_state, action) => action.payload,
);

const providerDetailsReducer = combineReducers({
  isFetching,
  providerDetails,
  errors,
});

export default providerDetailsReducer;
export type ProviderDetailsState = ReturnType<typeof providerDetailsReducer>;
